import { FloorSettings } from '@data';

import { queryClient } from '../config/client';
import { floorSettingsKey } from '../hooks/useFloorSettings';

export const updateFloorSettings = (userId: string, floorSettings: FloorSettings) => {
    queryClient.setQueryData(floorSettingsKey(userId), floorSettings);
};
